import React, { } from 'react';
import { useTranslation } from 'react-i18next';
import { colors, frames } from '../../../../Styles';
import { PageHeader, UserAndFarmSettings, SystemSettings, UserAdministration} from '../../../../Components';
import { Pages } from '../../../../Navigation/root';

export default function GlobalSettings() {
  const {t} = useTranslation()

  const seperator = <div style={{ width: "95%", height: "1px", backgroundColor: colors.greyDarkPrimary }} />

  return (
    <frames.Page_inner>
      <PageHeader topHeader={t(`menuHeaders.${Pages.globalSettings}`, {defaultValue: "global settings"})} subHeader={t("menuHeaders.overview", {defaultValue: "overview"})}/>
      <frames._page_inner_content_scroll>
        
        <div style={{display: "flex", gap: "20px", alignItems: "center", justifyContent: "center", flexDirection: "column"}}>
          {seperator}
          <UserAndFarmSettings />
          {seperator}
          <SystemSettings/>
          {seperator}
          <UserAdministration/>
        </div>
        
      </frames._page_inner_content_scroll>
    </frames.Page_inner>
  );
}